import { makeStyles } from '@mui/styles';

export const useReconcileWizardItemsStyle = makeStyles(() => ({
  cellStyle: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
  },
}));
